import React from 'react'
import { Button } from 'react-bootstrap'

import './MultiButtonSelector.scss'

export const MultiButtonSelector = ({ options, value, onClickOption }) => {
  return <div className={'multi-button-selector'}>
    {
      options
        .map((option) => (
          <Button
            key={option.key}
            bsStyle='link'
            active={option.key === value}
            onClick={() => onClickOption(option.key)}
          >
            {option.name}
          </Button>
      ))
    }
  </div>
}


// WEBPACK FOOTER //
// ./src/features/commons/SearchBar/components/MultiButtonSelector/MultButtonSelector.component.js